<section class="nearby-pros">
  <div class="nearby-pros__head">
    <h2 class="nearby-pros__title">{{ "UX_TEXT.NEARBY_PROS.TITLE" | translate }}</h2>
    <button type="button" class="nearby-pros__link" (click)="openMap()">
      {{ "UX_TEXT.NEARBY_PROS.VIEW_MAP" | translate }}
      <ion-icon name="chevron-forward-outline"></ion-icon>
    </button>
  </div>

  <div class="nearby-pros__map-card">
    <div class="nearby-pros__map" *ngIf="!isLoading; else nearbyMapSkeleton">
      <div class="nearby-pros__svg-wrap">
        <svg class="nearby-pros__svg" viewBox="0 0 400 400" xmlns="http://www.w3.org/2000/svg">
          <path
            d="M325.9,152.3 L320.5,157.9 L320.2,163.3 L313.7,170.5 L302.7,184.8 L299.8,197.8 L295.8,204.4 L304.7,200.4 L308.1,195.7 L317.0,196.8 L319.7,204.8 L323.6,211.5 L317.9,215.8 L322.3,223.2 L326.5,231.5 L324.1,239.3 L317.3,241.8 L316.1,247.5 L321.4,253.1 L322.2,259.6 L319.4,267.4 L321.8,274.7 L328.6,279.1 L336.5,280.2 L340.0,284.5 L335.4,290.9 L331.2,297.0 L326.7,298.8 L322.7,302.9 L318.8,308.2 L312.8,312.5 L313.4,316.7 L307.1,318.2 L301.5,319.7 L298.5,320.6 L294.4,320.1 L291.8,320.3 L287.6,316.7 L282.1,315.9 L280.2,311.8 L275.1,311.3 L270.5,308.7 L267.2,309.0 L259.6,309.5 L247.3,302.6 L232.4,313.4 L220.4,325.5 L220.7,341.2 L223.3,345.3 L215.1,344.8 L209.4,348.7 L201.5,345.6 L192.6,347.1 L187.6,340.3 L180.5,337.0 L175.2,334.6 L167.2,331.8 L159.2,331.3 L154.1,335.2 L145.8,334.3 L138.1,332.4 L131.4,331.2 L124.3,328.3 L116.2,324.7 L108.6,320.0 L106.2,315.8 L98.4,312.0 L99.4,308.4 L105.0,295.8 L108.3,278.5 L112.0,260.5 L114.6,259.5 L110.1,259.4 L111.2,244.3 L113.9,226.2 L110.6,222.0 L113.6,214.0 L112.6,205.5 L113.0,198.5 L105.4,196.3 L95.1,190.5 L86.5,175.6 L87.0,167.2 L84.4,161.7 L76.4,160.0 L78.3,154.3 L75.5,151.7 L75.3,150.7 L73.4,151.1 L68.5,152.0 L68.5,150.6 L71.8,149.2 L72.4,148.2 L70.3,147.5 L66.8,148.9 L65.6,147.9 L64.7,149.4 L61.2,149.5 L60.9,149.6 L60.7,144.6 L60.5,143.2 L59.2,145.4 L55.9,144.5 L56.1,142.2 L55.0,143.7 L50.7,140.2 L48.0,141.9 L46.1,140.5 L41.8,140.1 L39.2,137.6 L35.1,136.9 L35.1,136.1 L33.4,138.4 L30.8,140.9 L24.9,132.5 L20.0,132.1 L25.0,130.0 L31.7,128.3 L25.9,125.0 L22.7,123.3 L25.1,122.1 L32.2,123.6 L32.2,123.1 L31.3,121.3 L29.8,120.3 L30.0,117.9 L25.2,119.4 L19.3,119.6 L19.2,115.3 L20.8,111.6 L23.1,111.0 L24.6,109.5 L28.4,108.4 L33.0,108.3 L38.5,105.8 L40.0,109.2 L42.3,107.7 L47.8,106.9 L49.5,103.8 L53.1,102.1 L59.1,100.8 L62.0,100.2 L62.1,103.3 L66.2,104.5 L69.4,110.7 L74.8,112.2 L81.0,108.4 L84.0,109.7 L86.8,109.7 L90.4,112.0 L91.5,111.4 L91.6,107.0 L98.0,110.2 L104.6,108.4 L101.8,99.0 L101.3,95.1 L99.2,85.8 L94.9,79.3 L91.7,68.5 L98.8,70.2 L107.9,68.6 L108.9,75.8 L122.8,82.0 L142.9,82.1 L144.1,74.4 L154.7,64.2 L173.0,58.0 L184.5,48.9 L183.1,37.0 L183.1,28.6 L191.7,19.6 L200.7,17.3 L209.2,23.3 L215.2,29.7 L223.8,28.3 L226.6,36.0 L233.2,38.3 L237.3,45.2 L244.3,44.0 L250.2,46.7 L250.4,55.0 L254.0,58.7 L262.9,54.9 L266.4,54.9 L267.6,63.9 L274.9,68.0 L281.2,71.8 L288.1,74.2 L295.0,76.2 L301.0,76.0 L308.9,77.6 L313.8,84.4 L319.8,87.3 L326.5,90.5 L335.5,89.6 L345.3,93.6 L353.2,96.1 L342.4,114.7 L337.6,137.4 L335.8,151.8 L328.9,155.1 L325.9,152.3 Z"
            fill="rgba(29, 93, 155, 0.08)"
            stroke="rgba(29, 93, 155, 0.25)"
            stroke-width="1.2"
            stroke-linejoin="round"
            stroke-linecap="round"
          />
          <path
            d="M350,330 L352,325 L356,320 L360,316 L362,310 L364,304 L363,298 L360,294 L356,290 L354,286 L350,284 L347,288 L345,294 L344,300 L343,306 L344,312 L345,318 L347,324 L350,330 Z"
            fill="rgba(29, 93, 155, 0.08)"
            stroke="rgba(29, 93, 155, 0.25)"
            stroke-width="1.2"
            stroke-linejoin="round"
          />
        </svg>
        <div
          class="nearby-pros__state"
          *ngFor="let state of stateIconsWithCounts"
          [class.nearby-pros__state--active]="selectedStateName === state.name"
          [class.nearby-pros__state--has-providers]="state.activeCount > 0"
          [class.nearby-pros__state--empty]="state.activeCount === 0"
          [style.left]="state.left"
          [style.top]="state.top"
          [style.--state-delay]="state.delay"
          [attr.title]="state.name"
          (click)="onStateClick(state.name)"
        >
          <span class="nearby-pros__state-pulse"></span>
          <span class="nearby-pros__state-core"></span>
          <div class="nearby-pros__state-tooltip" *ngIf="selectedStateName === state.name">
            <p class="nearby-pros__state-name">{{ state.name }}</p>
            <p class="nearby-pros__state-count" [class.nearby-pros__state-count--empty]="state.activeCount === 0">
              {{ state.activeCount }} {{ "UX_TEXT.NEARBY_PROS.ONLINE_LABEL" | translate }}
            </p>
          </div>
        </div>
      </div>
    </div>
    <ng-template #nearbyMapSkeleton>
      <div class="nearby-pros__map nearby-pros__map--skeleton">
        <span class="nearby-pros__skeleton nearby-pros__skeleton--map-shape"></span>
        <span class="nearby-pros__skeleton nearby-pros__skeleton--map-dot nearby-pros__skeleton--map-dot-1"></span>
        <span class="nearby-pros__skeleton nearby-pros__skeleton--map-dot nearby-pros__skeleton--map-dot-2"></span>
        <span class="nearby-pros__skeleton nearby-pros__skeleton--map-dot nearby-pros__skeleton--map-dot-3"></span>
        <span class="nearby-pros__skeleton nearby-pros__skeleton--map-dot nearby-pros__skeleton--map-dot-4"></span>
      </div>
    </ng-template>

    <div class="nearby-pros__footer">
      <div class="nearby-pros__live">
        <span class="nearby-pros__live-dot"></span>
        <div>
          <p class="nearby-pros__count" *ngIf="!isLoading; else nearbyCountSkeleton">{{ displayCount }}</p>
          <p class="nearby-pros__label">{{ "UX_TEXT.NEARBY_PROS.ONLINE_LABEL" | translate }}</p>
        </div>
      </div>
      <span class="nearby-pros__chip">{{ "UX_TEXT.NEARBY_PROS.ALL_FRANCE" | translate }}</span>
    </div>
  </div>
  <ng-template #nearbyCountSkeleton>
    <span class="nearby-pros__skeleton nearby-pros__skeleton--count"></span>
  </ng-template>

  <div class="nearby-pros__stats" *ngIf="!isLoading; else nearbyStatsSkeleton">
    <div class="nearby-pros__stat" *ngFor="let stat of stats">
      <p class="nearby-pros__stat-value">{{ stat.value }}</p>
      <p class="nearby-pros__stat-label">{{ stat.labelKey | translate }}</p>
    </div>
  </div>
  <ng-template #nearbyStatsSkeleton>
    <div class="nearby-pros__stats">
      <div class="nearby-pros__stat nearby-pros__stat--skeleton" *ngFor="let _ of [1, 2, 3, 4]">
        <span class="nearby-pros__skeleton nearby-pros__skeleton--stat-value"></span>
        <span class="nearby-pros__skeleton nearby-pros__skeleton--stat-label"></span>
      </div>
    </div>
  </ng-template>
</section>
